import { Button, Card, CardActions, CardContent, TextField, makeStyles } from '@material-ui/core';
import { PhoneAndroid } from '@material-ui/icons';
import { FormBuilder } from '@zennya/web-component-library/src';
import { PageHeader } from 'pages/CustomerBookingCreate/components/PageHeader';
import { STEP_CREATE_ACCOUNT_REQUEST_VERIFICATION, STEP_CREATE_ACCOUNT_VERIFY_MOBILE, STEP_SERVICE_BREAKDOWN } from 'pages/CustomerBookingCreate/constants';
import { otpMobileNumberState, stepState } from 'pages/CustomerBookingCreate/state';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { toast } from 'react-hot-toast';
import { useHistory, useLocation } from 'react-router-dom';
import { useRecoilState } from 'recoil';
import { requestMobileNumberValidationCode } from 'services/authentication.service';
import { toasterror } from 'util/toasterror';
import { useTrackEvent } from 'util/trackEvent';
import * as Yup from 'yup';

const useStyles = makeStyles(theme => ({
  card: {
    padding: theme.spacing(5),
  },
  cardContent: {
    "&>*": {
      marginBottom: theme.spacing(5)
    }
  },
  cardAction: {
    justifyContent: 'flex-end'
  }
}));

const CreateAccountOTPScreen = ({ }) => {
  const classes = useStyles()
  const [step, setStep] = useRecoilState(stepState);
  const [error, setError] = useState(null);
  const [triggerSubmit, setTriggerSubmit] = useState(false);
  const [loading, setLoading] = useState(false);
  const history = useHistory()
  const bLocation = useLocation()
  const trackEvent = useTrackEvent()

  const [otpMobileNumber, setOtpMobileNumber]= useRecoilState(otpMobileNumberState);
  const sendVerification = useCallback(
    async (v) => {
      try {
        setLoading(true)
        await requestMobileNumberValidationCode({ number: v?.mobile_number })
        setOtpMobileNumber(v?.mobile_number)
        history.replace(STEP_CREATE_ACCOUNT_VERIFY_MOBILE, {defer:true})
        setLoading(false)
      } catch (error) {
        trackEvent('OTP - error', { error: error?.message?.en || error?.response?.data?.message?.en || error?.response?.data?.details })
        toasterror(error?.message?.en || error?.response?.data?.message?.en || error?.response?.data?.details, {error})
        setLoading(false)
      }
    },
    [],
  );

  const form = useMemo(
    () => {
      return {
        mobile_number: {
          type: 'phone',
          label: 'Mobile Number',
          initialValues: "",
          validator: () =>
            Yup.string()
              .required()
              .nullable()
              .matches(
                /^\+(63\d{10}|(?!63)\d{1,3}\d{10})$/,
                "invalid phone number format"
              )
              .label(" "),
          icon: <PhoneAndroid />
        }
      }
    }, []
  );
  return (
    <>
      <PageHeader
        title="Verify your mobile number"
        isCartEnabled={false}
        currentStep={STEP_CREATE_ACCOUNT_REQUEST_VERIFICATION}
        backStep={STEP_SERVICE_BREAKDOWN}
        showBreadcrumbs
        subheader={
          (
            <>
              We need to verify your mobile number to ensure that you can receive your live booking status and other important information.
            </>
          )
        }
        loading={loading}
      >
        <Card className={classes.card}>
          <CardContent className={classes.cardContent}>
            <FormBuilder
              variant="outlined"
              formFactor="default"
              hasReset={false}
              decouple
              triggerSubmit={triggerSubmit}
              onTriggerSubmit={v => {
                setTriggerSubmit(false)
              }}
              form={form}
              formLayout={['mobile_number']}
              onSubmit={(v) => sendVerification(v)}

            />
          </CardContent>
          <CardActions className={classes.cardAction}>
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                trackEvent('Create Booking OTP - send verification to mobile number')
                setTriggerSubmit(true)
              }}
            >
              Send confirmation code
            </Button>
          </CardActions>
        </Card>
      </PageHeader>
    </>
  )
}

export { CreateAccountOTPScreen }